const residentialService = () => {
  return {
    name: 'Residential Service',
    title: 'Residential Service Rate with Seasonal Variations',
    rateElements: [
      // Distribution Charges
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Distribution Charges - October through May',
        rateComponents: [
          {
            charge: 0.047989,
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            months: [9, 10, 11, 0, 1, 2, 3, 4],
            name: 'Up to 600 kWh',
          },
          {
            charge: 0.047989,
            min: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [9, 10, 11, 0, 1, 2, 3, 4],
            name: 'Over 600 kWh',
          },
        ],
      },
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Distribution Charges - June through September',
        rateComponents: [
          {
            charge: 0.082602,
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            months: [5, 6, 7, 8],
            name: 'Up to 600 kWh',
          },
          {
            charge: 0.086677,
            min: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [5, 6, 7, 8],
            name: 'Over 600 kWh',
          },
        ],
      },
      // Basic Generation Service Charges
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Basic Generation Service Charge - Summer',
        rateComponents: [
          {
            charge: 0.1318,
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            months: [5, 6, 7, 8],
            name: 'Up to 600 kWh',
          },
          {
            charge: 0.141148,
            min: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [5, 6, 7, 8],
            name: 'Over 600 kWh',
          },
        ],
      },
      {
        rateElementType: 'BlockedTiersInDays',
        name: 'Basic Generation Service Charge - Winter',
        rateComponents: [
          {
            charge: 0.134599,
            min: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            max: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            months: [9, 10, 11, 0, 1, 2, 3, 4],
            name: 'Up to 600 kWh',
          },
          {
            charge: 0.134599,
            min: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600],
            max: [
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
              'Infinity',
            ],
            months: [9, 10, 11, 0, 1, 2, 3, 4],
            name: 'Over 600 kWh',
          },
        ],
      },
      {
        rateElementType: 'SurchargeAsPercent',
        name: 'Transmission Charge',
        rateComponents: [
          {
            charge: 0.065877,
            name: 'All Use',
          },
        ],
      },
      {
        rateElementType: 'FixedPerMonth',
        name: 'Service Charge',
        rateComponents: [
          {
            charge: 5.63,
            name: 'Basic Service Charge',
          },
          {
            charge: 6.0,
            name: 'Service Charge with NJ Sales and Use Tax',
          },
        ],
      },
    ],
  };
};

export default residentialService;
